export default "__VITE_ASSET__7321e96b__"